document.addEventListener('DOMContentLoaded', function () {
	function accordion() {
		document.querySelectorAll('.accordion-atag').forEach(function (element) {
			element.addEventListener('click', function (e) {
				e.preventDefault();
				const parentTd = this.parentElement;
				if (parentTd.classList.contains('expand-open')) {
					parentTd.classList.remove('expand-open');
				} else {
					parentTd.classList.add('expand-open');
				}
			});
		});
	}
	function ajaxAccordion() {
		document.querySelectorAll('.accordion-ajax').forEach(function (element) {
			element.addEventListener('click', function (e) {
				e.preventDefault();
				const parentTd = this.parentElement;
				if (parentTd.classList.contains('expand-open')) {
					parentTd.classList.remove('expand-open');
				} else {
					parentTd.classList.add('expand-open');
				}
			});
		});
	}
	accordion();

	document
		.querySelectorAll('.investor-container .section-details h4')
		.forEach(function (element, index) {
			const cleanText = element.textContent.toLowerCase().replaceAll(' ', '-');
			const mainText = element.textContent;
			element.setAttribute('id', cleanText);
			let aClass = '';
			if (index === 0) {
				aClass = 'active';
			}
			const aTag = document.createElement('a');
			aTag.setAttribute('href', `#${cleanText}`);
			aTag.setAttribute('class', aClass);
			const pTag = document.createElement('p');
			pTag.setAttribute('class', 'p3');
			pTag.textContent = mainText;
			aTag.appendChild(pTag);
			document.querySelector('.investor-container .list-items').appendChild(aTag);

			const pTagOption = document.createElement('p');
			pTagOption.setAttribute('class', 'p3');
			pTagOption.textContent = mainText;
			const select = document.getElementById('menu-select');
			const option = document.createElement('option');
			option.appendChild(pTagOption);
			option.value = cleanText;
			select.add(option);
		});

	document.querySelectorAll('.team-main-heading').forEach(function (element, index) {
		const cleanText = element.textContent.toLowerCase().replaceAll(' ', '-');
		const mainText = element.textContent;
		element.setAttribute('id', cleanText);
		let aClass = '';
		if (index === 0) {
			aClass = 'active';
		}
		const aTag = document.createElement('a');
		aTag.setAttribute('href', `#${cleanText}`);
		aTag.setAttribute('class', aClass);
		const pTag = document.createElement('p');
		pTag.setAttribute('class', 'p3');
		pTag.textContent = mainText;
		aTag.appendChild(pTag);
		document.querySelector('.people-list-items').appendChild(aTag);

		const pTagOption = document.createElement('p');
		pTagOption.setAttribute('class', 'p3');
		pTagOption.textContent = mainText;
		const select = document.getElementById('menu-select');
		const option = document.createElement('option');
		option.appendChild(pTagOption);
		option.value = cleanText;
		select.add(option);
	});

	function dynamicMenuItemsToggle() {
		const links = document.querySelectorAll('.list-items a');
		links.forEach(function (link) {
			link.addEventListener('click', function (event) {
				event.preventDefault();
				let hrefVal = link.getAttribute('href');
				hrefVal = hrefVal.replace('#', '');
				const element = document.getElementById(hrefVal);
				const headerOffset = 100;
				const elementPosition = element.getBoundingClientRect().top;
				const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
				window.scrollTo({
					top: offsetPosition,
					behavior: 'smooth',
				});
				links.forEach(function (item) {
					item.classList.remove('active');
				});
				this.classList.add('active');
			});
		});
	}
	function dynamicSelectItemsToggle() {
		if (document.getElementById('menu-select')) {
			document.getElementById('menu-select').addEventListener('change', function () {
				const element = document.getElementById(this.value);
				let headerSectionHeight = 0;
				const isMobile = /Android|iPhone/i.test(navigator.userAgent);
				if (isMobile) {
					if (
						document.querySelector('.section-menu')?.offsetHeight &&
						document.querySelector('header').offsetHeight
					) {
						headerSectionHeight =
							document.querySelector('.section-menu')?.offsetHeight +
							document.querySelector('header').offsetHeight;
					}
				}
				const headerOffset = isMobile ? headerSectionHeight : 100;
				const elementPosition = element.getBoundingClientRect().top;
				const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
				window.scrollTo({
					top: offsetPosition,
					behavior: 'smooth',
				});
			});
		}
	}
	setTimeout(dynamicMenuItemsToggle, 2000);
	setTimeout(dynamicSelectItemsToggle, 2000);

	// Table view more and show less

	const shownDefault = 3;
	let numShown = shownDefault; // Initial rows shown & index
	const tableAll = document.querySelectorAll('.wp-block-table table'); // Table element
	const moretext = 'View more';
	const lesstext = 'View less';

	const wpBlockTable = document.querySelectorAll('.wp-block-table');
	wpBlockTable.forEach(function (item) {
		const moreButtonDiv = document.createElement('div');
		moreButtonDiv.setAttribute('class', 'more-button');
		const showMoreLink = document.createElement('a');
		showMoreLink.setAttribute('href', '');
		showMoreLink.setAttribute('class', 'show-more button-small');
		showMoreLink.textContent = moretext;
		moreButtonDiv.appendChild(showMoreLink);
		item.appendChild(moreButtonDiv);
		showMoreLink.addEventListener('click', function (e) {
			e.preventDefault();
			const table = this.closest('.wp-block-table').querySelector('table');
			const tbody = table.querySelector('tbody');
			const rows = tbody.querySelectorAll('tr');
			const numRows = rows.length;
			if (numShown === numRows) {
				numShown = shownDefault;
				for (let i = numShown; i < numRows; i += 1) {
					rows[i].style.display = 'none';
				}
				showMoreLink.textContent = moretext;
			} else {
				numShown = numRows;
				showMoreLink.textContent = lesstext;
			}
			for (let i = 0; i < numShown; i += 1) {
				rows[i].style.display = 'table-row';
			}
		});
	});

	tableAll.forEach(function (item) {
		const tbody = item.querySelector('tbody'); // tbody containing all the rows
		const rows = tbody.querySelectorAll('tr'); // All rows in the tbody
		const numRows = rows.length; // Total # rows
		if (numRows < shownDefault || numRows === shownDefault) {
			if (item?.parentElement?.children.length > 1) {
				item.parentElement.children[1].remove();
			}
		}
		for (let i = numShown; i < numRows; i += 1) {
			rows[i].style.display = 'none';
		}
	});

	const customAnnualReport = document.querySelectorAll('.custom_annual_report');
	const customTableAll = document.querySelectorAll('.custom_annual_report table'); // Table element
	customAnnualReport.forEach(function (item) {
		const moreButtonDiv = document.createElement('div');
		moreButtonDiv.setAttribute('class', 'more-button');
		const showMoreLink = document.createElement('a');
		showMoreLink.setAttribute('href', '');
		showMoreLink.setAttribute('class', 'show-more button-small');
		showMoreLink.textContent = moretext;
		moreButtonDiv.appendChild(showMoreLink);
		item.appendChild(moreButtonDiv);
		showMoreLink.addEventListener('click', function (e) {
			e.preventDefault();
			const table = this.closest('.custom_annual_report').querySelector('table');
			const tbody = table.querySelector('tbody');
			const rows = tbody.querySelectorAll('tr');
			const numRows = rows.length;
			if (numShown === numRows) {
				numShown = shownDefault;
				for (let i = numShown; i < numRows; i += 1) {
					rows[i].style.display = 'none';
				}
				showMoreLink.textContent = moretext;
			} else {
				numShown = numRows;
				showMoreLink.textContent = lesstext;
			}
			for (let i = 0; i < numShown; i += 1) {
				rows[i].style.display = 'table-row';
			}
		});
	});

	customTableAll.forEach(function (item) {
		const tbody = item.querySelector('tbody'); // tbody containing all the rows
		const rows = tbody.querySelectorAll('tr'); // All rows in the tbody
		const numRows = rows.length; // Total # rows
		if (numRows < shownDefault || numRows === shownDefault) {
			if (item?.parentElement?.children.length > 1) {
				item.parentElement.children[1].remove();
			}
		}
		for (let i = numShown; i < numRows; i += 1) {
			rows[i].style.display = 'none';
		}
	});

	// Delete Empty table row
	document.querySelectorAll('.wp-block-table table tbody tr').forEach(function (e) {
		if (e.textContent.trim().length === 0) {
			// if row is empty
			e.parentNode.removeChild(e);
		}
	});

	function loadMoreReports(item) {
		const idItem = item.getAttribute('id');
		const paged = item.getAttribute('data-paged');
		const perPage = item.getAttribute('data-page');
		const type = item.getAttribute('data-type');
		const maxPages = parseInt(item.getAttribute('data-max'), 0);
		const tableBody = document.getElementById(`table_${idItem}`);
		const xhr = new XMLHttpRequest();
		xhr.open('POST', ajaxload_params.ajaxurl); //eslint-disable-line
		xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		xhr.onload = function () {
			if (xhr.status === 200) {
				const response = JSON.parse(xhr.responseText);
				if (response) {
					const pagedFrom = response.paged;
					const dataSets = item.dataset;
					dataSets.paged = pagedFrom;
					if (parseInt(pagedFrom, 0) >= parseInt(maxPages, 0)) {
						item.parentElement.remove();
					}
					tableBody.insertAdjacentHTML('beforeend', response.html);
					ajaxAccordion();
				}
			}
		};
		xhr.send(
			`action=load_more_reports&slug=${idItem}&paged=${paged}&perPage=${perPage}&type=${type}`,
		);
	}

	const loadMoreButton = document.querySelectorAll('.load-more');
	if (loadMoreButton) {
		loadMoreButton.forEach(function (item) {
			const dataSets = item.dataset;
			const maxPages = parseInt(dataSets.max, 0);
			if (maxPages === 1) {
				item.parentElement.remove();
			}
			item.addEventListener('click', function (e) {
				e.preventDefault();
				loadMoreReports(item);
			});
		});
	}
});

document.addEventListener('DOMContentLoaded', function () {
	const element = document.getElementById('view-more-financial');

	if (element) {
		element.addEventListener('click', function (e) {
			e.preventDefault();
			const paged = element.getAttribute('data-paged');
			const xhr = new XMLHttpRequest();
			const url = ajaxload_params.ajaxurl; //eslint-disable-line

			xhr.open('POST', url, true);
			xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

			xhr.onreadystatechange = function () {
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						const response = JSON.parse(xhr.responseText);
						// Handle the AJAX response here
						const tableBody = document.getElementById('financial-table');
						const elementtable = document.getElementById('view-more-financial');
						elementtable.setAttribute('data-paged', response.paged_new);
						const maxpage = parseInt(elementtable.getAttribute('data-max'), 0);
						if (maxpage === response.paged_new) {
							const viewmore = document.getElementById('view-more-financial');
							viewmore.parentElement.remove();
						}
						tableBody.insertAdjacentHTML('beforeend', response.html);
					} else {
						console.log(`Error: ${xhr.status} (Status Code: ${xhr.statusText})`);
					}
				}
			};

			xhr.onerror = function () {
				console.log(`Error: ${xhr.status} (Status Code: ${xhr.statusText})`);
			};

			xhr.send(`action=load_more_financial_info&paged=${paged}`);
		});
	}

	let currentPage = 1;
	const perPage = 10;
	const countItems = document.querySelectorAll('.event-loadmore-container .row-wrapper').length;
	const reviewsListItems = document.querySelectorAll('.event-loadmore-container .row-wrapper');
	reviewsListItems.forEach(function (item) {
		const rowItem = item;
		rowItem.style.display = 'none';
	});
	const totalPages = countItems / perPage;
	const butttonLoad = document.getElementById('event-loadmore-button');
	if (countItems <= perPage && butttonLoad) {
		butttonLoad.style.display = 'none';
	}
	// Display first 10 items
	for (let i = 0; i < Math.min(perPage, countItems); i += 1) {
		reviewsListItems[i].style.display = 'flex';
	}
	if (butttonLoad) {
		butttonLoad.addEventListener('click', function () {
			reviewsListItems.forEach(function (item, index) {
				const inItem = item;
				if (index >= currentPage * perPage && index < (currentPage + 1) * perPage) {
					inItem.style.display = 'flex';
				}
			});
			currentPage += 1;
			if (currentPage >= totalPages) {
				this.style.display = 'none';
			}
		});
	}
});
